import React from 'react'
import PropTypes from 'prop-types'

import ChartAndInfo from '../ChartAndInfo'
import {
  _ChartsRow, _Col, _ChartBlock,
} from './styles.js'


const Composition = ({ data }) => {
  const householdCompos = data.data?.attributes?.household_composition?.variables

  return (
    <div>
      <h4>Household Composition</h4>

      <_ChartsRow>

        {householdCompos && householdCompos.map(type => (
          <_Col lg={3} sm={6} xs={12} key={type.label}>
            <_ChartBlock align="center">
              <ChartAndInfo
                percent={Math.round(type.value * 100)}
                iconName={type.variable.replace('_', '-')}
                title={type.label}
                // subtitle="Avg. age of children: 9"
              />
            </_ChartBlock>
          </_Col>
        ))}
      </_ChartsRow>
    </div>
  )
}


Composition.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.shape({
      attributes: PropTypes.shape({
        household_composition: PropTypes.shape({
          variables: PropTypes.arrayOf(PropTypes.shape({})),
        }),
      }),
    }),
  }),
}

export default Composition
